export default "/images/vendor/flag-icon-css/flags/4x3/as.svg?6fde2eb438bcef1efc2ddd729bf4ebc6";